// extracted by mini-css-extract-plugin
export default {"bar":"DisplayTabsBox_bar__AwfGx","container":"DisplayTabsBox_container__UEu-+","tab":"DisplayTabsBox_tab__2VFcm"};